module.exports = __webpack_public_path__ + "img/glasses-8-3.8df0b1af.svg";